import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
// import "./style.scss";

const CounterItem = ({
  startCount,
  endCount,
  plus,
  aboveThousand,
  duration,
  unit,
  separator,
}) => {
  return (
    <CountUp
      start={startCount}
      end={endCount}
      duration={duration ? duration : 5}
      separator={separator ? separator : ""}
    >
      {({ countUpRef, start }) => (
        <VisibilitySensor onChange={start}>
          <>
            <div className="common_actual_count">
              <span ref={countUpRef} />
              <span>{aboveThousand ? "K" : ""}</span>{" "}
              <span>{unit ? unit : ""}</span>
              <span>{plus ? "+" : ""}</span>
            </div>
          </>
        </VisibilitySensor>
      )}
    </CountUp>
  );
};

export default CounterItem;
